export default __webpack_public_path__ + "static/B0142-4e79dc06a2ebd5bcbbd3834728b77077.png";